interface GridPaginationProps {
  layoutMode: string
  totalPages: number
  safeGridPage: number
  onPageChange: (next: (prev: number) => number) => void
}

/**
 * Page controls for the tiled grid.
 *
 * All that remains of `DemoParticipantControls`, which also carried a
 * participant-count stepper — a demo affordance that let anyone dial the roster
 * up to 60 fake tiles. It shipped in the meeting UI, and its count doubled as
 * the cap on the real roster.
 */
export function GridPagination({
  layoutMode,
  totalPages,
  safeGridPage,
  onPageChange,
}: GridPaginationProps) {
  if (layoutMode !== 'tiled' || totalPages <= 1) return null

  return (
    <div className="absolute right-4 top-4 z-20 flex items-center gap-2 rounded-2xl bg-black/50 backdrop-blur-sm px-3 py-2 shadow-lg">
      <div className="flex items-center gap-1">
        <button
          type="button"
          onClick={() => onPageChange((p) => Math.max(0, p - 1))}
          disabled={safeGridPage <= 0}
          className="grid h-6 w-6 place-items-center rounded-full text-white/70 transition hover:bg-card/10 hover:text-white disabled:opacity-30"
          title="Previous page"
        >
          <svg className="h-3.5 w-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M15 19l-7-7 7-7" />
          </svg>
        </button>
        <span className="min-w-[40px] text-center text-[11px] font-semibold text-white/80 tabular-nums">
          {safeGridPage + 1}/{totalPages}
        </span>
        <button
          type="button"
          onClick={() => onPageChange((p) => Math.min(totalPages - 1, p + 1))}
          disabled={safeGridPage >= totalPages - 1}
          className="grid h-6 w-6 place-items-center rounded-full text-white/70 transition hover:bg-card/10 hover:text-white disabled:opacity-30"
          title="Next page"
        >
          <svg className="h-3.5 w-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M9 5l7 7-7 7" />
          </svg>
        </button>
      </div>
    </div>
  )
}
